import * as d3 from "d3";
import { ShotOverlayDto } from "../../models/shotOverlayDto";
import { ShotLocations } from "./xwai-viz.types";

export type MergedShot = ShotOverlayDto & { sx: number; sy: number; sz: number };

/** Pairs each fit with its source location (by `shot_id`); drops shots with no location. */
export function mergeShotOverlay(
  fits: ShotOverlayDto[],
  locations: ShotLocations,
): MergedShot[] {
  return fits
    .map((fit) => ({ ...fit, ...locations[fit.shot_id] }))
    .filter((shot): shot is MergedShot => shot.sx != null && shot.sy != null);
}

/** Colours shots by traces_fit: min → black, max → white (clamped). */
export function shotFitColorScale(min: number, max: number) {
  return d3
    .scaleLinear<string>()
    .domain([min, max])
    .range(["#000000", "#ffffff"])
    .clamp(true);
}
